module.exports = __webpack_public_path__ + "media/assets/images/smart_working/3-3-26d1c00b16a2d6913382950c857caf0f.png";